import { ca } from '@cian/analytics';

export const trackIndexTransportMoreClick = () => {
  ca('eventSite', {
    action: 'click',
    category: 'Index_transport',
    label: 'index_transport_more',
    name: 'oldevent',
    useLastProducts: true,
  });
};
